import { computed } from 'vue'

function getSectionForm(getForm, section) {
  const form = typeof getForm === 'function' ? getForm() : getForm
  return form?.[section] || {}
}

function normalizeModelValue(value, isSelect) {
  if (!isSelect) return value ?? ''
  return value === '' || value === null ? undefined : value
}

export function createFieldModel(getForm, section, key, emit, options = {}) {
  return computed({
    get: () => normalizeModelValue(getSectionForm(getForm, section)?.[key], options.select),
    set: value => emit('update-field', { key, value })
  })
}
